import { IExpenseVendor, IExpenseVendorCreate, IExpenseVendorUpdate } from "../models/IExpenseVendor";
import { configWithUserToken } from "./config";

export const getExpenseVendors = (includeDisabled = false) =>
  configWithUserToken.get<IExpenseVendor[]>(`ExpenseVendor?includeDisabled=${includeDisabled}`);

export const getExpenseVendorById = (vendorId: string) =>
  configWithUserToken.get<IExpenseVendor>(`ExpenseVendor/${vendorId}`);

export const createExpenseVendor = (data: IExpenseVendorCreate) =>
  configWithUserToken.post<IExpenseVendor>("ExpenseVendor", data);

export const updateExpenseVendor = (vendorId: string, data: IExpenseVendorUpdate) =>
  configWithUserToken.put<IExpenseVendor>(`ExpenseVendor/${vendorId}`, data);

export const deleteExpenseVendor = (vendorId: string) =>
  configWithUserToken.delete(`ExpenseVendor/${vendorId}`);
